import axios from "axios";

export const resolveCustomerReview = ({
  customerId,
  action,
  comment = "",
  instanceUniqueId,
  source,
}) => axios.put(
  `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${customerId}/review`,
  {
    action,
    comment,
    ...(instanceUniqueId ? { instanceUniqueId } : {}),
    ...(source ? { source } : {}),
  },
  { headers: { accessToken: localStorage.getItem("accessToken") } },
);
